// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Colors from "common/src/Colors.bs.js";
import * as Global from "common/src/Global.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as D3Force from "d3-force";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";

function WrappedUnitBubbles(Props) {
  var unitStats = Props.unitStats;
  var unitDistribution = Props.unitDistribution;
  var topCompanions = Props.topCompanions;
  var basePath3 = CdnAtom.usePath4(undefined);
  var unitDistribution$1 = React.useMemo((function () {
          return Belt_Array.map(unitDistribution, (function (param) {
                        return [
                                param[0],
                                Caml.caml_float_min(Caml.caml_float_max(param[1], -100), 100),
                                Caml.caml_float_min(Caml.caml_float_max(param[2], -100), 100)
                              ];
                      }));
        }), []);
  React.useState(function () {
        return 0;
      });
  var match = React.useState(function () {
        return false;
      });
  var setIsDone = match[1];
  var match$1 = React.useState(function () {
        var totCount = Global.f(Belt_Array.reduce(Js_dict.values(unitStats), 0, (function (acc, v) {
                    return acc + v | 0;
                  })));
        var statsLen = Js_dict.entries(unitStats).length;
        var unitNodes = Belt_Array.mapWithIndex(Belt_Array.slice(Belt_SortArray.stableSortBy(Js_dict.entries(unitStats), (function (param, param$1) {
                        return Caml.caml_string_compare(param[0], param$1[0]);
                      })), 0, 100), (function (idx, param) {
                var unitId = param[0];
                var d = unitDistribution$1.find(function (param) {
                      return param[0] === unitId;
                    });
                var match = d !== undefined ? [
                    d[1] * 100,
                    d[2] * 100
                  ] : [
                    0,
                    0
                  ];
                return {
                        index: idx,
                        unit: Data.fixId(unitId),
                        x: match[0],
                        y: match[1],
                        vx: 0,
                        vy: 0,
                        r: Math.pow(Global.f(param[1]) / totCount * 75000, 0.45)
                      };
              }));
        var unitsAvgX = Belt_Array.reduce(unitNodes, 0, (function (acc, v) {
                return acc + v.x;
              })) / Global.f(unitNodes.length);
        var unitsAvgY = Belt_Array.reduce(unitNodes, 0, (function (acc, v) {
                return acc + v.y;
              })) / Global.f(unitNodes.length);
        var unitNodes$1 = Belt_Array.map(unitNodes, (function (node) {
                return {
                        index: node.index,
                        unit: node.unit,
                        x: node.x - unitsAvgX,
                        y: node.y - unitsAvgY,
                        vx: node.vx,
                        vy: node.vy,
                        r: node.r
                      };
              }));
        var nodes = Belt_Array.concat(unitNodes$1, Belt_Array.mapWithIndex(Belt_Array.keep(unitDistribution$1, (function (param) {
                        return !param[0].startsWith("TFT");
                      })), (function (idx, param) {
                    var id = param[0];
                    var count = Belt_Option.getWithDefault(Js_dict.get(topCompanions, id), 0);
                    return {
                            index: statsLen + idx | 0,
                            unit: id,
                            x: param[1],
                            y: param[2],
                            vx: 0,
                            vy: 0,
                            r: Math.pow(Global.f(count) / totCount * 125000, 0.4)
                          };
                  })));
        var sim = D3Force.forceSimulation(nodes).alphaDecay(0.0035).alphaMin(0.1).force("many-body", D3Force.forceManyBody().strength(function (node) {
                              return 40;
                            }).distanceMax(function (node) {
                            return 100;
                          })).force("force-x", D3Force.forceX(function (node) {
                            return 0;
                          }).strength(function (node) {
                          if (Math.abs(node.y) > 400) {
                            return 0.01;
                          } else if (Math.abs(node.x) > 275) {
                            return 0.006;
                          } else {
                            return 0.004;
                          }
                        })).force("force-y", D3Force.forceY(function (node) {
                          return 0;
                        }).strength(function (node) {
                        if (Math.abs(node.y) > 400) {
                          return 0.01;
                        } else if (Math.abs(node.y) > 275) {
                          return 0.006;
                        } else {
                          return 0.004;
                        }
                      })).force("collision", D3Force.forceCollide(function (node) {
                      return node.r + 0.75;
                    })).force("center", D3Force.forceCenter(0, 0)).tick(700);
        sim.on("end", (function (a) {
                return Curry._1(setIsDone, (function (param) {
                              return true;
                            }));
              }));
        return sim;
      });
  var sim = match$1[0];
  var minX = Belt_Array.reduce(sim.nodes(), 600, (function (acc, node) {
          return Math.min(acc, node.x - node.r);
        }));
  var minY = Belt_Array.reduce(sim.nodes(), 600, (function (acc, node) {
          return Math.min(acc, node.y - node.r);
        }));
  var maxX = Belt_Array.reduce(sim.nodes(), 0, (function (acc, node) {
          return Math.max(acc, node.x + node.r);
        }));
  var maxY = Belt_Array.reduce(sim.nodes(), 0, (function (acc, node) {
          return Math.max(acc, node.y + node.r);
        }));
  var centerX = (minX + maxX) / 2;
  var centerY = (minY + maxY) / 2;
  if (match[0]) {
    return React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: "pt-10 w-full flex justify-center"
                  }, React.createElement("h4", {
                        className: "font-medium text-2xl pb-0 text-primary-11"
                      }, "Group photo of everyone who stood beside you")), React.createElement("svg", {
                    className: "ml-[-15px] mb-4",
                    height: "670",
                    width: "670"
                  }, React.createElement("rect", {
                        height: "568",
                        width: "568",
                        fill: "rgba(255, 255, 255, 0.08)",
                        x: "46",
                        y: "46"
                      }), React.createElement("defs", undefined, React.createElement("clipPath", {
                            id: "circleView"
                          }, React.createElement("circle", {
                                cx: "250",
                                cy: "125",
                                fill: "#FFFFFF",
                                r: "125"
                              }))), React.createElement("g", {
                        transform: "translate(" + Global.toFixed(undefined, 325 - centerX) + ", " + Global.toFixed(undefined, 325 - centerY) + ")"
                      }, Belt_Array.mapWithIndex(Belt_SortArray.stableSortBy(sim.nodes(), (function (n1, n2) {
                                  return Caml.caml_float_compare(n1.r, n2.r);
                                })), (function (idx, node) {
                              var strokeWidth = node.r < 10 ? "1" : (
                                  node.r < 15 ? "1.5" : (
                                      node.r < 30 ? "2" : (
                                          node.r < 50 ? "2.5" : "3"
                                        )
                                    )
                                );
                              var tmp;
                              if (node.unit.startsWith("TFT")) {
                                var href = "https://ap.tft.tools/img/face/" + node.unit + ".jpg";
                                tmp = React.createElement(React.Fragment, undefined, React.createElement("image", {
                                          key: "circle-" + String(idx),
                                          height: Global.toFixed(undefined, node.r * 2),
                                          href: href,
                                          width: Global.toFixed(undefined, node.r * 2),
                                          clipPath: "circle()",
                                          x: Global.toFixed(undefined, node.x - node.r),
                                          y: Global.toFixed(undefined, node.y - node.r)
                                        }), React.createElement("circle", {
                                          cx: Global.toFixed(undefined, node.x),
                                          cy: Global.toFixed(undefined, node.y),
                                          fill: "none",
                                          r: Global.toFixed(undefined, node.r),
                                          stroke: "#" + Colors.tierColor(Sd.unitTier(node.unit)),
                                          strokeWidth: strokeWidth
                                        }));
                              } else {
                                tmp = React.createElement(React.Fragment, undefined, React.createElement("image", {
                                          key: "circle-" + String(idx),
                                          height: Global.toFixed(undefined, node.r * 2),
                                          href: basePath3 + "/ll-icons/" + node.unit + ".png",
                                          width: Global.toFixed(undefined, node.r * 2),
                                          clipPath: "circle()",
                                          x: Global.toFixed(undefined, node.x - node.r),
                                          y: Global.toFixed(undefined, node.y - node.r)
                                        }), React.createElement("circle", {
                                          cx: Global.toFixed(undefined, node.x),
                                          cy: Global.toFixed(undefined, node.y),
                                          fill: "none",
                                          r: Global.toFixed(undefined, node.r),
                                          stroke: "var(--white1)",
                                          strokeWidth: strokeWidth
                                        }));
                              }
                              return React.createElement("g", {
                                          key: String(idx)
                                        }, tmp);
                            }))), React.createElement("image", {
                        height: "670",
                        href: "https://ap.tft.tools/static/img/general/wrapped-frame.svg",
                        width: "670"
                      })));
  } else {
    return null;
  }
}

var make = WrappedUnitBubbles;

export {
  make ,
  
}
/* Sd Not a pure module */
